import compose from 'ramda/src/compose'
import pathOr from 'ramda/src/pathOr'
import isMultiSelector from 'root/src/client/logic/form/selectors/isMultiSelector'
import { formStoreLenses } from 'root/src/client/logic/form/lenses'

const { pathOrFormInputs } = formStoreLenses

export default (state, { moduleKey, fieldPath, fieldDescPath }) => {
	const isMulti = isMultiSelector(state, { moduleKey, fieldDescPath })
	return compose(
		pathOr(isMulti ? [] : undefined, fieldPath),
		pathOrFormInputs(moduleKey, {}),
	)(state)
}
